// Desktop hover dropdown menu with debounce delay
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth >= 990) {
    const menuItems = document.querySelectorAll('.header__inline-menu > ul > li');
    const OPEN_DELAY = 150; // Open delay in ms
    const CLOSE_DELAY = 300; // Close delay in ms

    menuItems.forEach(item => {
      const details = item.querySelector('details');
      if (!details) return;

      let openTimer = null;
      let closeTimer = null;

      // Clear all timers
      const clearTimers = () => {
        if (openTimer) {
          clearTimeout(openTimer);
          openTimer = null;
        }
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      };

      // Open menu on mouse enter (with delay)
      item.addEventListener('mouseenter', () => {
        clearTimers();
        openTimer = setTimeout(() => {
          details.setAttribute('open', '');
        }, OPEN_DELAY);
      });

      // Close menu on mouse leave (with delay)
      item.addEventListener('mouseleave', () => {
        clearTimers();
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
        }, CLOSE_DELAY);
      });

      // Handle submenus (nested dropdowns)
      const subDetails = details.querySelectorAll('details');
      subDetails.forEach(subDetail => {
        const parentLi = subDetail.closest('li');

        if (parentLi) {
          let subOpenTimer = null;
          let subCloseTimer = null;

          const clearSubTimers = () => {
            if (subOpenTimer) {
              clearTimeout(subOpenTimer);
              subOpenTimer = null;
            }
            if (subCloseTimer) {
              clearTimeout(subCloseTimer);
              subCloseTimer = null;
            }
          };

          parentLi.addEventListener('mouseenter', () => {
            clearSubTimers();
            subOpenTimer = setTimeout(() => {
              subDetail.setAttribute('open', '');
            }, OPEN_DELAY);
          });

          parentLi.addEventListener('mouseleave', () => {
            clearSubTimers();
            subCloseTimer = setTimeout(() => {
              subDetail.removeAttribute('open');
            }, CLOSE_DELAY);
          });
        }
      });
    });
  }
});
